import { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';

export function usePartnerTemplates(partnerClientId) {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!partnerClientId) {
      setTemplates([]);
      setLoading(false);
      return;
    }

    const db = firebase.firestore();
    let query = db.collectionGroup('template_tags');

    if (partnerClientId === 'all') {
      query = query
        .where('product', '!=', null)
        .where('is_test', 'in', [true, false]);
    } else {
      query = query.where('partnerClientId', '==', partnerClientId);
    }

    const unsubscribe = query.onSnapshot((snapshot) => {
      const docs = snapshot.docs.map(doc => {
        const pathSegments = doc.ref.path.split('/');
        // Path is issuers/{issuerId}/template_tags/{templateId}
        const issuerId = pathSegments[1];
        return { id: doc.id, issuerId, ...doc.data() };
      });
      setTemplates(docs);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching partner templates:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [partnerClientId]);

  return [loading, templates];
}

